import { Textarea } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useDebouncedCallback } from '../../../../../../../../../../hooks/useDebouncedCallback'
import { useSendAsEmailForm } from '../../../../../../contexts/sendAsEmailFormContext'
import { useTrackSendAsEmail } from '../../../../../../hooks/useTrackSendAsEmail'

export const EmailMessage = (): ReactElement => {
  const { t } = useTranslation()
  const { sendAsEmailForm } = useSendAsEmailForm()
  const { trackSendAsEmail } = useTrackSendAsEmail()
  const { FormItem } = sendAsEmailForm

  const handleDebouncedTextareaChange = useDebouncedCallback(() => trackSendAsEmail('Message field modified'))

  return (
    <FormItem
      label={t('external_invoices.send_as_email.modal.form.field.message.label')}
      name="emailMessage"
      render={({ field: { onChange, ...rest } }) => {
        return (
          <Textarea
            {...rest}
            expandOnType
            maxHeight={160}
            onChange={(event) => {
              onChange(event)
              handleDebouncedTextareaChange()
            }}
            placeholder={t('external_invoices.send_as_email.modal.form.field.message.placeholder')}
            resizable={false}
            rows={5}
            size="sm"
          />
        )
      }}
    />
  )
}
